import { useSyncExternalStore } from 'react';

// Was die obere Leiste links zeigt, wenn eine Bestellung offen ist und
// ihr Kopf weggescrollt wurde (03.11.2026, Skizze B): Nummer · Kunde ·
// Zustand. Die Bestellseite meldet es hierher, die Leiste liest es.
//
// Ein kleiner Speicher statt eines Kontexts, weil Leiste und Seite in
// verschiedenen Ästen des Baums hängen (die Leiste im PageLayout, die
// Seite im Outlet) und ein Provider darüber nur dafür da wäre.

export type KopfBestellung = {
  bestellnr: string;
  kunde: string;
  zustand: string | null;
};

type Stand = {
  bestellung: KopfBestellung | null;
  kopfSichtbar: boolean;
  /**
   * Der Zurück-Weg der Seite (E63) — DIESELBE Funktion, die ihr eigener
   * Knopf ruft (hooks/useZurueck.ts), nicht nachgebaut. Die Leiste löst
   * damit genau dieselbe Navigation aus; die Verlassen-Nachfrage (E48)
   * hängt am Blocker der Seite und greift deshalb hier wie dort.
   */
  zurueck: (() => void) | null;
};

let stand: Stand = { bestellung: null, kopfSichtbar: true, zurueck: null };
const hoerer = new Set<() => void>();

function setzen(neu: Stand): void {
  if (
    neu.kopfSichtbar === stand.kopfSichtbar &&
    neu.zurueck === stand.zurueck &&
    neu.bestellung?.bestellnr === stand.bestellung?.bestellnr &&
    neu.bestellung?.kunde === stand.bestellung?.kunde &&
    neu.bestellung?.zustand === stand.bestellung?.zustand
  ) {
    return;
  }
  stand = neu;
  hoerer.forEach((h) => h());
}

/** Die Bestellseite meldet sich an (null beim Verlassen). */
export function kopfBestellungSetzen(b: KopfBestellung | null): void {
  setzen({ ...stand, bestellung: b, kopfSichtbar: b === null ? true : stand.kopfSichtbar });
}

/** Die Seite veröffentlicht ihren Zurück-Weg (null beim Verlassen). */
export function kopfZurueckSetzen(zurueck: (() => void) | null): void {
  setzen({ ...stand, zurueck });
}

/** Ist der Kopf der Bestellung gerade im Bild? */
export function kopfSichtbarSetzen(sichtbar: boolean): void {
  setzen({ ...stand, kopfSichtbar: sichtbar });
}

export function useKopfKontext(): Stand {
  return useSyncExternalStore(
    (h) => {
      hoerer.add(h);
      return () => hoerer.delete(h);
    },
    () => stand,
    () => stand
  );
}
